import React from 'react';
import '../css/styles.css';
import laser_cutting from "../img/laser_cutting.jfif";
import metal_bending from "../img/metal_bending.jpg";
import {Link} from 'react-router-dom';

export default function Services() {
  return (
    <>
    
<section id="services" className="services">
        <div className="container aos-init aos-animate" data-aos="fade-up">
  
          <div className="section-title">
            <h3>Our Services</h3><br />
            <span>We provide The Best In Class Services For Our Customers</span>
          </div>
  
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 d-flex mt-3 aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
              <div id="laser" className="box-img">
                <div id="laser-box" className="img-fluid"></div>
                <h4><a href="#">CNC Laser Cutting Services<br/>&nbsp;</a></h4>
                <span id="btn-getquote" className="btn cap-getquote"><Link to="/contact">Get Quote</Link></span><br />
                <span className="btn cap-explore"><Link to="/laser_cutting">EXPLORE MORE</Link></span>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 d-flex mt-3 aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
              <div id="laser" className="box-img">
                <div id="metal-bending-box" className="img-fluid"></div>
                <h4><a href="#">CNC Bending Services<br/>&nbsp;</a></h4>
                <span id="btn-getquote" className="btn cap-getquote"><Link to="/contact">Get Quote</Link></span><br />
                <span className="btn cap-explore"><Link to="/metal_bending">EXPLORE MORE</Link></span>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 d-flex mt-3 aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
              <div id="laser" className="box-img">
                <div id="fabrication-box" className="img-fluid"></div>
                <h4><a href="#">Fabrication Services<br/>&nbsp;</a></h4>
                <span id="btn-getquote" className="btn cap-getquote"><Link to="/contact">Get Quote</Link></span><br />
                <span className="btn cap-explore"><Link to="/metal_fabrication">EXPLORE MORE</Link></span>
              </div>
            </div>
         
          </div>
  
        </div>
      </section>
    </>
  )
}
